export const thursdayUppercase = "Gu9ZPb";
export default {thursdayUppercase};